const mapColors = [
    "#0056ff",
    "#666666",//"#ff2e2e",
    "#4c606e",
    "#d4dadf",
    "#ebeced",
    "#d4dde4",
    "#d4dde4"
]

const markerIcon1 = {
    url: '/assets/images/mark1.png',
    scaledSize: null
}
const markerIcon2 = {
    url: '/assets/images/mark2.png',
    scaledSize: null
}

const mapStyles = [{
    "featureType": "administrative",
    "elementType": "all",
    "stylers": [{"visibility": "simplified"}]
}, {
    "featureType": "administrative.province",
    "elementType": "labels",
    "stylers": [{"visibility": "simplified"}]
}, {
    "featureType": "administrative.province",
    "elementType": "labels.text.fill",
    "stylers": [{"hue": mapColors[0]}, {"visibility": "off"}]
}, {
    // "featureType": "administrative.locality",
    // "elementType": "labels",
    // "stylers": [{"color": mapColors[1]}, {"visibility": "on"}]
// }, {
    "featureType": "administrative.locality",
    "elementType": "labels.text",
    "stylers": [{"visibility": "on"}]
}, {
    "featureType": "administrative.neighborhood",
    "elementType": "labels",
    "stylers": [{"color": mapColors[2]}, {"visibility": "simplified"}]
}, {
    "featureType": "administrative.neighborhood",
    "elementType": "labels.text",
    "stylers": [{"visibility": "simplified"}]
}, {
    "featureType": "administrative.neighborhood",
    "elementType": "labels.text.fill",
    "stylers": [{"color": mapColors[2]}]
}, {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text",
    "stylers": [{"visibility": "simplified"}]
}, {
    "featureType": "landscape",
    "elementType": "geometry",
    "stylers": [{"visibility": "simplified"}, {"color": mapColors[4]}]
}, {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [{"visibility": "simplified"}, {"color": mapColors[4]}]
}, {
    "featureType": "poi",
    "elementType": "labels",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "poi.attraction",
    "elementType": "labels",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [{"visibility": "simplified"}, {"color": mapColors[3]}]
}, {
    "featureType": "road.highway",
    "elementType": "labels",
    "stylers": [{"visibility": "on"}]
}, {
    "featureType": "road.highway",
    "elementType": "labels.text",
    "stylers": [{"visibility": "on"}]
}, {
    "featureType": "road.highway",
    "elementType": "labels.icon",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "road.highway.controlled_access",
    "elementType": "labels",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "road.highway.controlled_access",
    "elementType": "labels.text",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "road.highway.controlled_access",
    "elementType": "labels.icon",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [{"visibility": "simplified"}, {"color": mapColors[3]}]
}, {
    "featureType": "road.arterial",
    "elementType": "labels",
    "stylers": [{"visibility": "simplified"}]
}, {
    "featureType": "road.arterial",
    "elementType": "labels.text",
    "stylers": [{"visibility": "on"}]
}, {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [{"visibility": "simplified"}, {"color": mapColors[3]}]
}, {
    "featureType": "road.local",
    "elementType": "labels.text",
    "stylers": [{"visibility": "simplified"}]
}, {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [{"color": "#233146"}]
}, {
    "featureType": "road.local",
    "elementType": "labels.icon",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "transit.station",
    "elementType": "labels.text.fill",
    "stylers": [{"color": "#ba5858"}]
}, {
    "featureType": "transit.station",
    "elementType": "labels.icon",
    "stylers": [{"hue": "#ff0036"}]
}, {
    "featureType": "transit.station.rail",
    "elementType": "labels.icon",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [{"visibility": "simplified"}, {"color": mapColors[5]}]
}, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": mapColors[6]}]}]

/**
 * Returns the zoom level at which the given rectangular region fits in the map view.
 * The zoom level is computed for the currently selected map type.
 * @param {google.maps.Map} map
 * @param {google.maps.LatLngBounds} bounds
 * @return {Number} zoom level
 **/
function getZoomByBounds(map, bounds) {
    var MAX_ZOOM = 8 //map.mapTypes.get(map.getMapTypeId()).maxZoom;
    var MIN_ZOOM = 2 //map.mapTypes.get(map.getMapTypeId()).minZoom;

    if (!map.getProjection()) {
        return 8
    }
    var ne = map.getProjection().fromLatLngToPoint(bounds.getNorthEast());
    var sw = map.getProjection().fromLatLngToPoint(bounds.getSouthWest());

    var worldCoordWidth = Math.abs(ne.x - sw.x);
    var worldCoordHeight = Math.abs(ne.y - sw.y);

    //Fit padding in pixels
    var FIT_PAD = 40;

    for (var zoom = MAX_ZOOM; zoom >= MIN_ZOOM; --zoom) {
        if (worldCoordWidth * (1 << zoom) + 2 * FIT_PAD < $(map.getDiv()).width() &&
            worldCoordHeight * (1 << zoom) + 2 * FIT_PAD < $(map.getDiv()).height())
            return zoom > 2 ? zoom - 1 : 2;
    }
    return 2;
}

function initMap(id) {
    markerIcon1.scaledSize =  new google.maps.Size(24, 40);
    markerIcon2.scaledSize =  new google.maps.Size(24, 40);
    return new google.maps.Map(document.getElementById(id), {
        zoom: 2,
        center: {lat: 0, lng: 0},
        minZoom: 2,
        maxZoom: 18,
        styles: mapStyles,
        streetViewControl: false,
        mapTypeControl: false,
        scrollwheel: false
    });
}

function initMapMarkerAnimation(marker) {
    marker.setIcon(markerIcon1);

    let bounceTimer
    let bounceStart = function () {
        if (marker.getAnimation() == null || typeof marker.getAnimation() === 'undefined') {
            marker.setIcon(markerIcon2);
            /*
             Because of the google maps bug of moving cursor several times over and out of marker
             causes bounce animation to break - we use small timer before triggering the bounce animation
             */
            clearTimeout(bounceTimer);
            bounceTimer = setTimeout(function () {
                    marker.setAnimation(google.maps.Animation.BOUNCE);
                },
                500);

        }
    }

    let bounceEnd = function () {
        if (marker.getAnimation() != null) {
            marker.setAnimation(null);
        }
        marker.setIcon(markerIcon1);
        clearTimeout(bounceTimer);
    }


    /* animazione */
    google.maps.event.addListener(marker, 'mouseover', function () {
        bounceStart()
    });

    google.maps.event.addListener(marker, 'mouseout', function () {
        bounceEnd();
    });

    return {
        start: bounceStart,
        end: bounceEnd,
        marker: marker
    };
}

function initMapMarkerInfo(map, marker, content) {
    let infowindow = new google.maps.InfoWindow({
        content: content
    })
    marker.addListener('click', function () {
        infowindow.open(map, marker)
    })
}

function initMapCenter(map, bounds) {
    google.maps.event.trigger(map, "resize")
    if (bounds) {
        map.setCenter(bounds.getCenter())
        map.setZoom(getZoomByBounds(map, bounds))
    } else {
        map.setCenter({lat: 0, lng: 0})
        map.setZoom(2)
    }
    google.maps.event.trigger(map, "resize")
}

export {initMap, initMapMarkerAnimation, initMapMarkerInfo, initMapCenter}



// WEBPACK FOOTER //
// ./app/Resources/assets/js/front/mapStyle.jsx